import { render, staticRenderFns } from "./MdTableGenericFields.vue?vue&type=template&id=876c4e2a&"
import script from "./MdTableGenericFields.vue?vue&type=script&lang=js&"
export * from "./MdTableGenericFields.vue?vue&type=script&lang=js&"
import style0 from "./MdTableGenericFields.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports